module.exports = __webpack_public_path__ + "media/goforajourney/img/barcelona-tour-ea6eac41132086915e5a476f2241a0f2.webp";